import __base_store from '@/store/__base_store'

/**
 * Store de comisiones (modelo `commission`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'commission',
	},
})

